import React, { ComponentType } from "react";
import { RootStore } from "./rootStore";
import hoistNonReactStatics from "hoist-non-react-statics";

type RootStoreContextStores = {
  rootStore: RootStore;
};

const RootStoreContext = React.createContext<RootStoreContextStores>(
  {} as RootStoreContextStores,
);

const rootStore = new RootStore();

export const RootStoreProvider: React.FC<React.PropsWithChildren<{}>> = ({
  children,
}) => {
  return (
    <RootStoreContext.Provider value={{ rootStore }}>
      {children}
    </RootStoreContext.Provider>
  );
};

export const useRootStore = () => React.useContext(RootStoreContext);

export type TWithStoreHOC = <P extends object>(
  Component: ComponentType<P>,
) => (props: P) => JSX.Element;

export const withStore: TWithStoreHOC = (WrappedComponent) => (props) => {
  const ComponentWithStore = () => {
    const store = useRootStore();

    return <WrappedComponent {...props} store={store} />;
  };

  ComponentWithStore.defaultProps = { ...WrappedComponent.defaultProps };
  ComponentWithStore.displayName = `WithStores(${
    WrappedComponent.name || WrappedComponent.displayName
  })`;

  hoistNonReactStatics(ComponentWithStore, WrappedComponent);

  return <ComponentWithStore />;
};
